module.exports = __webpack_public_path__ + "img/bitcoin-sign.8f88a14f.svg";